import React from 'react'
import { useTranslation } from 'react-i18next'

import { AbsenceRequestCard } from '..'
import { Spinner } from '../../../App/Components'
import { useAppSelector } from '../../../App/Hooks/reduxHooks'
import { useGetAbsenceRequestListQuery } from '../../../HR/AbsenceRequestNew/util/useAbsenceRequestQuery'

import { FilterButton } from './FilterButton/FilterButton'
import { AbsenceCardTitle, TextBlock, TitleContainer } from './style'

interface IProps {
  activeType: string | null
  onChange: (e: string) => void
}

export const AbsenceRequestCardOverview = ({
  activeType,
  onChange,
}: IProps) => {
  const { data, status } = useGetAbsenceRequestListQuery()

  const { t } = useTranslation()
  const { user } = useAppSelector(state => {
    return {
      user: state.users.currentUser,
    }
  })

  if (status === 'pending' || !user) {
    return <Spinner />
  }

  if (status === 'error') {
    return <p>something went wrong</p>
  }

  const filteredCards = data
    .map(absenceRequest => {
      if (
        absenceRequest.person.uuid === user.uuid &&
        (absenceRequest.absenceType.key === activeType || null === activeType)
      ) {
        return (
          <AbsenceRequestCard
            key={absenceRequest.id}
            absenceRequest={absenceRequest}
            actionType={'edit'}
            showTrash
          />
        )
      }

      return null
    })
    .filter(card => null !== card)

  return (
    <>
      <TitleContainer>
        <AbsenceCardTitle>{t('My Requests')}</AbsenceCardTitle>
        <FilterButton
          onClick={() => onChange(null)}
          categoryFilter={activeType !== null}
        />
      </TitleContainer>
      {filteredCards.length > 0 ? (
        filteredCards
      ) : (
        <TextBlock>{t('No absence requests found.')}</TextBlock>
      )}
    </>
  )
}
